import { useEffect, useState } from "react";
import { Mail, Phone, GraduationCap, Building2, Briefcase, Calendar } from "lucide-react";
import { api } from "../../lib/api";

export default function AdminInternships() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/internships/applications")
      .then((r) => setItems(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-[#475569]">Loading internship applications…</div>;

  return (
    <div data-testid="admin-internships" className="max-w-5xl">
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#2563EB]">Recruitment</div>
        <h1 className="font-display text-3xl md:text-4xl font-semibold text-[#0F172A] mt-2">Internship Applications</h1>
        <p className="text-[#475569] mt-2 text-sm">
          {items.length} application{items.length === 1 ? "" : "s"} received.
        </p>
      </div>

      <div className="space-y-4">
        {items.length === 0 && (
          <div className="rounded-2xl border border-dashed border-blue-200 p-10 text-center text-[#475569]">
            No applications yet. Applications submitted via <code className="text-[#2563EB]">/internship</code> will appear here.
          </div>
        )}
        {items.map((a) => (
          <div key={a.id} data-testid={`intern-app-${a.id}`} className="bg-white border border-blue-100 rounded-2xl p-5 md:p-6">
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div>
                <div className="font-display text-xl text-[#0F172A]">{a.name}</div>
                <div className="text-xs uppercase tracking-[0.18em] text-[#475569] mt-1">{a.track} · {a.duration}</div>
              </div>
              <span className="text-[10px] uppercase tracking-[0.18em] bg-blue-50 text-[#1D4ED8] rounded-full px-3 py-1">{a.status}</span>
            </div>
            <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-3 text-sm text-[#0F172A]">
              <Field icon={Mail} val={a.email} href={`mailto:${a.email}`} />
              <Field icon={Phone} val={a.phone} href={`tel:${a.phone}`} />
              <Field icon={Building2} val={a.institution} />
              <Field icon={GraduationCap} val={a.course || "—"} />
              <Field icon={Calendar} val={a.year || "—"} />
              <Field icon={Briefcase} val={a.track} />
            </div>
            {a.cover_letter && (
              <div className="mt-4 pt-4 border-t border-blue-100 text-sm text-[#475569] whitespace-pre-wrap">
                {a.cover_letter}
              </div>
            )}
            <div className="mt-3 text-[11px] text-[#94A3B8]">Submitted: {new Date(a.created_at).toLocaleString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Field({ icon: Icon, val, href }) {
  const content = (
    <span className="inline-flex items-center gap-2">
      <Icon size={14} className="text-[#2563EB]" /> {val}
    </span>
  );
  return href ? <a href={href} className="hover:text-[#2563EB]">{content}</a> : content;
}
